export default __webpack_public_path__ + "static/media/ShowcaseBackground.68831b62.webp";